import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useCallback } from 'react';
import { isMobile } from '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '../../../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgClose } from '../../../../shared/assets/close.js';
import '../../../../utils/constants/colors.js';
import { useOnClickOutside } from '../../../../shared/utils/hooks/useOnClickOutside/index.js';
import '../../../../shared/consts/index.js';
import { useTransition } from '../../../../utils/hooks/useTransition/useTransition.js';
import { classNames } from '../../../../utils/functions/classNames/classNames.js';
import { Typography } from '../../../../components/Typography/Typography.js';
import '../../../../context/DynamicContext/DynamicContext.js';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { IconButton } from '../../../../components/IconButton/IconButton.js';

const DotsMenuWrapper = ({ children, onClose, content, showMenu, title, alignment = 'bottom', }) => {
    const ref = useRef(null);
    const closeOnOutsideClick = useCallback((event) => {
        event.stopPropagation();
        onClose();
    }, [onClose]);
    const handleOnClose = useCallback((event) => {
        event.stopPropagation();
        onClose();
    }, [onClose]);
    useOnClickOutside(ref, closeOnOutsideClick);
    const { mount, stage, currentDuration } = useTransition({
        inDuration: isMobile() ? 300 : 100,
        isShown: showMenu,
        outDuration: isMobile() ? 400 : 100,
    });
    const alignmentClassName = classNames({
        'dots-menu-wrapper__container__alignment__bottom': alignment === 'bottom',
        'dots-menu-wrapper__container__alignment__top': alignment === 'top',
    });
    const menuAnimationClassName = classNames('dots-menu-wrapper__container', alignmentClassName, {
        'dots-menu-wrapper__container--entering': stage === 'ENTERING',
        'dots-menu-wrapper__container--exiting': stage === 'EXITING',
    });
    return (jsxs("div", Object.assign({ className: 'dots-menu-wrapper', ref: ref }, { children: [children, showMenu && (jsx("div", { className: 'dots-menu-wrapper__backdrop', onClick: handleOnClose, "data-testid": 'dots-menu-wrapper__backdrop' })), mount && (jsxs("div", Object.assign({ className: menuAnimationClassName, onClick: handleOnClose, style: {
                    animationDuration: `${currentDuration}ms`,
                } }, { children: [jsxs("div", Object.assign({ className: 'dots-menu-wrapper__header' }, { children: [jsx("div", { className: 'dots-menu-wrapper__header__icon' }), jsx(Typography, Object.assign({ variant: 'body_normal', color: 'primary' }, { children: title })), jsx("div", Object.assign({ className: 'dots-menu-wrapper__header__icon' }, { children: jsx(IconButton, Object.assign({ "data-testid": 'close-icon-button', onClick: handleOnClose }, { children: jsx(SvgClose, {}) })) }))] })), content] })))] })));
};

export { DotsMenuWrapper };
